import React from 'react'
import { useIntl } from 'react-intl'
import {
  FormElement,
  InputText,
  Flex,
  CounterMono,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { messageState } from '../../recoil/state/message'
import { useRecoilState } from 'recoil'

// Preheader: Maxlength=100

const InputPreHeader = () => {
  const intl = useIntl()
  // caratteri massimi del campo summary
  const MAX_SUMMARY_CHARACTER = 100
  const [{ preHeader }, setPreHeaderState] = useRecoilState(messageState)

  const handleChangeTitle = e => {
    e.stopPropagation()
    e.preventDefault()
    const value = e.target.value
    if (value.length > MAX_SUMMARY_CHARACTER) {
      return
    }
    setPreHeaderState(prev => ({
      ...prev,
      preHeader: value,
      isDirty: true
    }))
  }

  return (
    <FormElement>
      <Flex
        alignItems='center'
        justifyContent='space-between'
        margin='0 0 4px 0'
      >
        <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
          {intl.formatMessage({ id: 'Load.SavedEmailWizard.PreheaderLabel' })}
        </Text>
        <CounterMono
          label={intl.formatMessage({
            id: 'Load.SavedEmailWizard.PreheaderCounter'
          })}
          count={`
              ${MAX_SUMMARY_CHARACTER - (preHeader ? preHeader.length : 0)} /
              ${MAX_SUMMARY_CHARACTER}
              `}
        />
      </Flex>
      <InputText
        placeholder={intl.formatMessage({
          id: 'Load.SavedEmailWizard.PreheaderPlaceholder'
        })}
        onChange={handleChangeTitle}
        maxLength='100'
        value={preHeader}
        data-mu-test='input-preheader'
      />
    </FormElement>
  )
}

export default InputPreHeader
